var _rect, _path, _path2, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowFees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2111 27.2115L26.1641 30.5585L29.5101 29.5105L30.5581 26.1635L27.2111 27.2115ZM25.0201 32.4515C24.8241 32.4515 24.6321 32.3745 24.4891 32.2325C24.2921 32.0345 24.2201 31.7435 24.3041 31.4785L25.8971 26.3895C25.9701 26.1535 26.1541 25.9705 26.3881 25.8975L31.4771 24.3045C31.7441 24.2195 32.0341 24.2925 32.2321 24.4895C32.4291 24.6875 32.5011 24.9785 32.4171 25.2435L30.8251 30.3325C30.7521 30.5675 30.5671 30.7515 30.3331 30.8245L25.2441 32.4175C25.1701 32.4405 25.0941 32.4515 25.0201 32.4515Z",
    fill: "#5034C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9420_106987",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18H38.7218V38.7217H18V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9420_106987)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.361 19.5C23.475 19.5 19.5 23.476 19.5 28.361C19.5 33.247 23.475 37.222 28.361 37.222C33.247 37.222 37.222 33.247 37.222 28.361C37.222 23.476 33.247 19.5 28.361 19.5ZM28.361 38.722C22.648 38.722 18 34.074 18 28.361C18 22.648 22.648 18 28.361 18C34.074 18 38.722 22.648 38.722 28.361C38.722 34.074 34.074 38.722 28.361 38.722Z",
    fill: "#5034C4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9F5FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowFees);
export default __webpack_public_path__ + "static/media/low-fees.6ecdbefb0fe1a90a8111d7c312bbc48f.svg";
export { ForwardRef as ReactComponent };